import React from "react";
import InfoContext from "../../context";
import PersonalArea from "./PersonalArea";

function ContextPersonalArea({ match, history }) {
  return (
    <div>
      <InfoContext>
        <PersonalArea match={match} history={history} />
      </InfoContext>
    </div>
  );
}

export default ContextPersonalArea;
